import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

const getTrendLineChartDataApi = ({ cohort }) => {
  const url = endpoints.analytics.review.trendLineChart;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohort,
      groupByKeys: null,
      splitByKeys: null,
      orderBy: null,
      parentUuid: null,
      timeBounds: [],
    },
  });
};

export default getTrendLineChartDataApi;
